// extracted by mini-css-extract-plugin
export default {"input-box":"Input_input-box__kBFM9","text-input":"Input_text-input__3sPLm","isEmpty":"Input_isEmpty__XmJR3"};